import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  Person,
  AddTask as AddTaskIcon,
  History as HistoryIcon,
  LocalPharmacy as DepartmentIcon,
} from '@mui/icons-material';

import DepartmentLayout from '../Layout/DepartmentLayout';
import Home from './Home';
import Prescriptions from './Prescriptions';
import Requisition from './Requisition';

// Placeholder for the Medication History tab (matches existing behavior — was a stub).
function MedicationHistoryPlaceholder() {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5">Medication History</Typography>
    </Box>
  );
}

// Pharmacy now participates in the DB-backed permission system so the
// Admin → Component Access page can grant/deny each menu item per role.
// Department id 18 matches the seed in `data/department.js` and the rows
// inserted by migration 014_pharmacy_component_access.sql. If the DB has
// no permission rows yet for a role, DepartmentLayout falls back to
// showing every menu item (no lockout).
const MENU_ITEMS = [
  { key: 'Home',              label: 'Home',               icon: <Person />,         component: Home },
  { key: 'Prescription',      label: 'Prescription',       icon: <AddTaskIcon />,    component: Prescriptions },
  { key: 'Requisition',       label: 'Requisition',        icon: <AddTaskIcon />,    component: Requisition },
  { key: 'MedicationHistory', label: 'Medication History', icon: <HistoryIcon />,    component: MedicationHistoryPlaceholder },
];

export default function Pharmacy() {
  return (
    <DepartmentLayout
      departmentId={18}
      departmentName="Pharmacy"
      departmentIcon={<DepartmentIcon />}
      menuItems={MENU_ITEMS}
    />
  );
}
